import { lazy } from 'react';
import Loadable from '@/components/base-component/Loadable';
import PagesLayout from '@/layout/Pages';

//============ Page Components ===============
// งบวิจัย - Research Budget
const Dashboard = Loadable(lazy(() => import('@/pages/dashboard/dashboard')));
const ResearchBudget = Loadable(lazy(() => import('@/pages/dashboard/research-budget')));
const ResearchBudgetCreate = Loadable(lazy(() => import('@/pages/dashboard/research-budget/component/create')));
const ResearchBudgetEdit = Loadable(lazy(() => import('@/pages/dashboard/research-budget/component/edit')));
// ::: ลำดับชั้นของ Path จะต้องเรียงลำดับให้ตรงในรายการ allowUsers List -->
// ::: ที่อยู่ของรายการ allowUsers List ==> /src/components/bs-component/menu-items/users
export const reseachRoutes = [
  {
    path: 'dashboard', // ไม่ต้องมี "/"
    element: <Dashboard />
  },
  {
    path: 'budget', // ไม่ต้องมี "/"
    element: <PagesLayout />,
    children: [
      {
        path: 'list', // ไม่ต้องมี "/"
        element: <ResearchBudget />
      },
      {
        path: 'create', // ไม่ต้องมี "/"
        element: <ResearchBudgetCreate />
      },
      {
        path: 'edit', // ไม่ต้องมี "/"
        element: <ResearchBudgetEdit />
      }
    ]
  }
];
